import * as React from 'react';
import PropTypes from 'prop-types';
import './InvoiceDetail.scss';
import i18n from 'i18n-react';
import { InvoiceType, Operation } from '../../../../const/CancelModel';
import { Row, Col } from 'antd';
import CancelDetail from '../../../flightDetailsPage/components/cancelDetail/CancelDetail';

const propTypes = {
	data: PropTypes.any,
	balanceColor: PropTypes.any
}

class InvoiceDetail extends React.Component {

	formatValue(value) {
		return Math.abs(value)
			.toFixed(2)
			.replace('.', ',')
			.replace(/(\d)(?=(\d{3})+,)/g, '$1.');
	}

	currencyPrefix(label, operation) {
		const labelWithPrefix = i18n.translate(label);
		return operation === Operation.PAYMENT || operation === Operation.PAYMENT_FREE ? `- ${labelWithPrefix}` : labelWithPrefix;
	}

	render() {
		const props = this.props;
		const invoice = props.data.simulation.invoice;
		const TOTAL_PAYMENT = invoice[InvoiceType[InvoiceType.TOTAL_PAYMENT]].value;
		const BALANCE = invoice[InvoiceType[InvoiceType.BALANCE]].value;
		const OPERATION = props.data.simulation.operation;

		return (
			<div className="InvoiceDetail">
				<CancelDetail
					balance={BALANCE}
					totalPayment={TOTAL_PAYMENT}
					totalSimulate={props.data.simulation.total}
					quotationDate={props.data.date}
					operation={props.data.simulation.operation}
					passengerInfo={props.data.passengerInfo}
				/>
				<div
					className={`InvoiceDetail__clientBalanceBackground padding-top-xl bg-${props.balanceColor}`}
					data-test="balanceBg"
				>
					<Row>
						<Col span={8} className="padding-left-xl text-white">
							<span data-unit="clientBalance">
								<b>{i18n.translate('label.clientBalance').toString()}</b>
							</span>
						</Col>
						<Col span={16} className="text-white text-right padding-right-xl">
							<span data-unit="balance" data-test="balance">
								{this.currencyPrefix('label.currency', OPERATION)}
								{this.formatValue(BALANCE)}
							</span>
						</Col>
					</Row>
				</div>
				<div className="text-red text-sm">
					<span data-unit="cancelFee" data-test="cancelFee">
						{this.getExchangeRateMessage(props)}
					</span>
				</div>
			</div>
		);
	}

	getExchangeRateMessage(props) {
		const exchangeRate = props.data.payment.exchangeRate;
		let message;
		if (exchangeRate != null) {
			message = i18n.translate('label.exchangeRateMessage', {
				exchangeRate: this.getValueFormatted(exchangeRate)
			});
		} else {
			message = i18n.translate('label.exchangeRateMessageWithoutExchangeRate');
		}
		return message;
	}

	getValueFormatted(value) {
		return value
			.toFixed(2)
			.replace('.', ',')
			.replace(/(\d)(?=(\d{3})+,)/g, '$1.');
	}

}

InvoiceDetail.propTypes = propTypes;

export default InvoiceDetail;





// WEBPACK FOOTER //
// ./src/page/cancelPnr/components/InvoiceDetail/InvoiceDetail.jsx